module.exports = __webpack_public_path__ + "img/hiking001.b9b6264c.jpg";